// source: proto/entity/organization.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var proto_common_crudFields_pb = require('../../proto/common/crudFields_pb.js');
goog.object.extend(proto, proto_common_crudFields_pb);
var proto_common_objectID_pb = require('../../proto/common/objectID_pb.js');
goog.object.extend(proto, proto_common_objectID_pb);
goog.exportSymbol('proto.entity.InternalOrganizationDetails', null, global);
goog.exportSymbol('proto.entity.NewOrganization', null, global);
goog.exportSymbol('proto.entity.Organization', null, global);
goog.exportSymbol('proto.entity.OrganizationDetails', null, global);
goog.exportSymbol('proto.entity.OrganizationSelector', null, global);
goog.exportSymbol('proto.entity.OrganizationSelector.SelectorCase', null, global);
goog.exportSymbol('proto.entity.UpdateOrganizationAction', null, global);
goog.exportSymbol('proto.entity.UpdateOrganizationAction.ActionCase', null, global);
goog.exportSymbol('proto.entity.UpdateOrganizationAction.SetDeletedAction', null, global);
goog.exportSymbol('proto.entity.UpdateOrganizationAction.SetDetailsAction', null, global);
goog.exportSymbol('proto.entity.UpdateOrganizationAction.SetInternalDetailsAction', null, global);
goog.exportSymbol('proto.entity.UpdateOrganizationAction.SetNameAction', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OrganizationSelector = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.OrganizationSelector.oneofGroups_);
};
goog.inherits(proto.entity.OrganizationSelector, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OrganizationSelector.displayName = 'proto.entity.OrganizationSelector';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.NewOrganization = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.NewOrganization, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.NewOrganization.displayName = 'proto.entity.NewOrganization';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.Organization = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.Organization, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.Organization.displayName = 'proto.entity.Organization';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OrganizationDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.OrganizationDetails.repeatedFields_, null);
};
goog.inherits(proto.entity.OrganizationDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OrganizationDetails.displayName = 'proto.entity.OrganizationDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.InternalOrganizationDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.InternalOrganizationDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.InternalOrganizationDetails.displayName = 'proto.entity.InternalOrganizationDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateOrganizationAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.UpdateOrganizationAction.oneofGroups_);
};
goog.inherits(proto.entity.UpdateOrganizationAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateOrganizationAction.displayName = 'proto.entity.UpdateOrganizationAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateOrganizationAction.SetNameAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateOrganizationAction.SetNameAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateOrganizationAction.SetNameAction.displayName = 'proto.entity.UpdateOrganizationAction.SetNameAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateOrganizationAction.SetDetailsAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateOrganizationAction.SetDetailsAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateOrganizationAction.SetDetailsAction.displayName = 'proto.entity.UpdateOrganizationAction.SetDetailsAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateOrganizationAction.SetInternalDetailsAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateOrganizationAction.SetInternalDetailsAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.displayName = 'proto.entity.UpdateOrganizationAction.SetInternalDetailsAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateOrganizationAction.SetDeletedAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateOrganizationAction.SetDeletedAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateOrganizationAction.SetDeletedAction.displayName = 'proto.entity.UpdateOrganizationAction.SetDeletedAction';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.OrganizationSelector.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.entity.OrganizationSelector.SelectorCase = {
  SELECTOR_NOT_SET: 0,
  ORGANIZATION_ID: 1,
  ALIAS: 2
};

/**
 * @return {proto.entity.OrganizationSelector.SelectorCase}
 */
proto.entity.OrganizationSelector.prototype.getSelectorCase = function() {
  return /** @type {proto.entity.OrganizationSelector.SelectorCase} */(jspb.Message.computeOneofCase(this, proto.entity.OrganizationSelector.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OrganizationSelector.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OrganizationSelector.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OrganizationSelector} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OrganizationSelector.toObject = function(includeInstance, msg) {
  var f, obj = {
    organizationId: (f = msg.getOrganizationId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    alias: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OrganizationSelector}
 */
proto.entity.OrganizationSelector.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OrganizationSelector;
  return proto.entity.OrganizationSelector.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OrganizationSelector} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OrganizationSelector}
 */
proto.entity.OrganizationSelector.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setOrganizationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlias(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OrganizationSelector.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OrganizationSelector.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OrganizationSelector} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OrganizationSelector.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional common.ObjectID organization_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.OrganizationSelector.prototype.getOrganizationId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.OrganizationSelector} returns this
*/
proto.entity.OrganizationSelector.prototype.setOrganizationId = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.entity.OrganizationSelector.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OrganizationSelector} returns this
 */
proto.entity.OrganizationSelector.prototype.clearOrganizationId = function() {
  return this.setOrganizationId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OrganizationSelector.prototype.hasOrganizationId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string alias = 2;
 * @return {string}
 */
proto.entity.OrganizationSelector.prototype.getAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OrganizationSelector} returns this
 */
proto.entity.OrganizationSelector.prototype.setAlias = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.entity.OrganizationSelector.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.entity.OrganizationSelector} returns this
 */
proto.entity.OrganizationSelector.prototype.clearAlias = function() {
  return jspb.Message.setOneofField(this, 2, proto.entity.OrganizationSelector.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OrganizationSelector.prototype.hasAlias = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.NewOrganization.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.NewOrganization.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.NewOrganization} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.NewOrganization.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    alias: jspb.Message.getFieldWithDefault(msg, 2, ""),
    details: (f = msg.getDetails()) && proto.entity.OrganizationDetails.toObject(includeInstance, f),
    internalDetails: (f = msg.getInternalDetails()) && proto.entity.InternalOrganizationDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.NewOrganization}
 */
proto.entity.NewOrganization.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.NewOrganization;
  return proto.entity.NewOrganization.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.NewOrganization} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.NewOrganization}
 */
proto.entity.NewOrganization.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlias(value);
      break;
    case 3:
      var value = new proto.entity.OrganizationDetails;
      reader.readMessage(value,proto.entity.OrganizationDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    case 4:
      var value = new proto.entity.InternalOrganizationDetails;
      reader.readMessage(value,proto.entity.InternalOrganizationDetails.deserializeBinaryFromReader);
      msg.setInternalDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.NewOrganization.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.NewOrganization.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.NewOrganization} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.NewOrganization.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAlias();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.OrganizationDetails.serializeBinaryToWriter
    );
  }
  f = message.getInternalDetails();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.entity.InternalOrganizationDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.entity.NewOrganization.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.NewOrganization} returns this
 */
proto.entity.NewOrganization.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string alias = 2;
 * @return {string}
 */
proto.entity.NewOrganization.prototype.getAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.NewOrganization} returns this
 */
proto.entity.NewOrganization.prototype.setAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional OrganizationDetails details = 3;
 * @return {?proto.entity.OrganizationDetails}
 */
proto.entity.NewOrganization.prototype.getDetails = function() {
  return /** @type{?proto.entity.OrganizationDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.OrganizationDetails, 3));
};


/**
 * @param {?proto.entity.OrganizationDetails|undefined} value
 * @return {!proto.entity.NewOrganization} returns this
*/
proto.entity.NewOrganization.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewOrganization} returns this
 */
proto.entity.NewOrganization.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewOrganization.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional InternalOrganizationDetails internal_details = 4;
 * @return {?proto.entity.InternalOrganizationDetails}
 */
proto.entity.NewOrganization.prototype.getInternalDetails = function() {
  return /** @type{?proto.entity.InternalOrganizationDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.InternalOrganizationDetails, 4));
};


/**
 * @param {?proto.entity.InternalOrganizationDetails|undefined} value
 * @return {!proto.entity.NewOrganization} returns this
*/
proto.entity.NewOrganization.prototype.setInternalDetails = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewOrganization} returns this
 */
proto.entity.NewOrganization.prototype.clearInternalDetails = function() {
  return this.setInternalDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewOrganization.prototype.hasInternalDetails = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.Organization.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.Organization.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.Organization} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.Organization.toObject = function(includeInstance, msg) {
  var f, obj = {
    organizationId: (f = msg.getOrganizationId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    alias: jspb.Message.getFieldWithDefault(msg, 3, ""),
    details: (f = msg.getDetails()) && proto.entity.OrganizationDetails.toObject(includeInstance, f),
    internalDetails: (f = msg.getInternalDetails()) && proto.entity.InternalOrganizationDetails.toObject(includeInstance, f),
    crudFields: (f = msg.getCrudFields()) && proto_common_crudFields_pb.CRUDFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.Organization}
 */
proto.entity.Organization.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.Organization;
  return proto.entity.Organization.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.Organization} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.Organization}
 */
proto.entity.Organization.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setOrganizationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlias(value);
      break;
    case 4:
      var value = new proto.entity.OrganizationDetails;
      reader.readMessage(value,proto.entity.OrganizationDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    case 5:
      var value = new proto.entity.InternalOrganizationDetails;
      reader.readMessage(value,proto.entity.InternalOrganizationDetails.deserializeBinaryFromReader);
      msg.setInternalDetails(value);
      break;
    case 6:
      var value = new proto_common_crudFields_pb.CRUDFields;
      reader.readMessage(value,proto_common_crudFields_pb.CRUDFields.deserializeBinaryFromReader);
      msg.setCrudFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.Organization.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.Organization.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.Organization} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.Organization.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAlias();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.entity.OrganizationDetails.serializeBinaryToWriter
    );
  }
  f = message.getInternalDetails();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.entity.InternalOrganizationDetails.serializeBinaryToWriter
    );
  }
  f = message.getCrudFields();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto_common_crudFields_pb.CRUDFields.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.ObjectID organization_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.Organization.prototype.getOrganizationId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.Organization} returns this
*/
proto.entity.Organization.prototype.setOrganizationId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Organization} returns this
 */
proto.entity.Organization.prototype.clearOrganizationId = function() {
  return this.setOrganizationId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Organization.prototype.hasOrganizationId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.entity.Organization.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.Organization} returns this
 */
proto.entity.Organization.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string alias = 3;
 * @return {string}
 */
proto.entity.Organization.prototype.getAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.Organization} returns this
 */
proto.entity.Organization.prototype.setAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional OrganizationDetails details = 4;
 * @return {?proto.entity.OrganizationDetails}
 */
proto.entity.Organization.prototype.getDetails = function() {
  return /** @type{?proto.entity.OrganizationDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.OrganizationDetails, 4));
};


/**
 * @param {?proto.entity.OrganizationDetails|undefined} value
 * @return {!proto.entity.Organization} returns this
*/
proto.entity.Organization.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Organization} returns this
 */
proto.entity.Organization.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Organization.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional InternalOrganizationDetails internal_details = 5;
 * @return {?proto.entity.InternalOrganizationDetails}
 */
proto.entity.Organization.prototype.getInternalDetails = function() {
  return /** @type{?proto.entity.InternalOrganizationDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.InternalOrganizationDetails, 5));
};


/**
 * @param {?proto.entity.InternalOrganizationDetails|undefined} value
 * @return {!proto.entity.Organization} returns this
*/
proto.entity.Organization.prototype.setInternalDetails = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Organization} returns this
 */
proto.entity.Organization.prototype.clearInternalDetails = function() {
  return this.setInternalDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Organization.prototype.hasInternalDetails = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional common.CRUDFields crud_fields = 6;
 * @return {?proto.common.CRUDFields}
 */
proto.entity.Organization.prototype.getCrudFields = function() {
  return /** @type{?proto.common.CRUDFields} */ (
    jspb.Message.getWrapperField(this, proto_common_crudFields_pb.CRUDFields, 6));
};


/**
 * @param {?proto.common.CRUDFields|undefined} value
 * @return {!proto.entity.Organization} returns this
*/
proto.entity.Organization.prototype.setCrudFields = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Organization} returns this
 */
proto.entity.Organization.prototype.clearCrudFields = function() {
  return this.setCrudFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Organization.prototype.hasCrudFields = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.OrganizationDetails.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OrganizationDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OrganizationDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OrganizationDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OrganizationDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingAccountId: (f = msg.getBillingAccountId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    allowedDomainsAndEmailsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OrganizationDetails}
 */
proto.entity.OrganizationDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OrganizationDetails;
  return proto.entity.OrganizationDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OrganizationDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OrganizationDetails}
 */
proto.entity.OrganizationDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setBillingAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAllowedDomainsAndEmails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OrganizationDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OrganizationDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OrganizationDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OrganizationDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingAccountId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getAllowedDomainsAndEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional common.ObjectID billing_account_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.OrganizationDetails.prototype.getBillingAccountId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.OrganizationDetails} returns this
*/
proto.entity.OrganizationDetails.prototype.setBillingAccountId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OrganizationDetails} returns this
 */
proto.entity.OrganizationDetails.prototype.clearBillingAccountId = function() {
  return this.setBillingAccountId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OrganizationDetails.prototype.hasBillingAccountId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated string allowed_domains_and_emails = 2;
 * @return {!Array<string>}
 */
proto.entity.OrganizationDetails.prototype.getAllowedDomainsAndEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.OrganizationDetails} returns this
 */
proto.entity.OrganizationDetails.prototype.setAllowedDomainsAndEmailsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.OrganizationDetails} returns this
 */
proto.entity.OrganizationDetails.prototype.addAllowedDomainsAndEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.OrganizationDetails} returns this
 */
proto.entity.OrganizationDetails.prototype.clearAllowedDomainsAndEmailsList = function() {
  return this.setAllowedDomainsAndEmailsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.InternalOrganizationDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.InternalOrganizationDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.InternalOrganizationDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.InternalOrganizationDetails.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.InternalOrganizationDetails}
 */
proto.entity.InternalOrganizationDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.InternalOrganizationDetails;
  return proto.entity.InternalOrganizationDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.InternalOrganizationDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.InternalOrganizationDetails}
 */
proto.entity.InternalOrganizationDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.InternalOrganizationDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.InternalOrganizationDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.InternalOrganizationDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.InternalOrganizationDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.UpdateOrganizationAction.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.entity.UpdateOrganizationAction.ActionCase = {
  ACTION_NOT_SET: 0,
  SET_NAME: 1,
  SET_DETAILS: 2,
  SET_INTERNAL_DETAILS: 3,
  SET_DELETED: 4
};

/**
 * @return {proto.entity.UpdateOrganizationAction.ActionCase}
 */
proto.entity.UpdateOrganizationAction.prototype.getActionCase = function() {
  return /** @type {proto.entity.UpdateOrganizationAction.ActionCase} */(jspb.Message.computeOneofCase(this, proto.entity.UpdateOrganizationAction.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateOrganizationAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateOrganizationAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateOrganizationAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOrganizationAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    setName: (f = msg.getSetName()) && proto.entity.UpdateOrganizationAction.SetNameAction.toObject(includeInstance, f),
    setDetails: (f = msg.getSetDetails()) && proto.entity.UpdateOrganizationAction.SetDetailsAction.toObject(includeInstance, f),
    setInternalDetails: (f = msg.getSetInternalDetails()) && proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.toObject(includeInstance, f),
    setDeleted: (f = msg.getSetDeleted()) && proto.entity.UpdateOrganizationAction.SetDeletedAction.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateOrganizationAction}
 */
proto.entity.UpdateOrganizationAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateOrganizationAction;
  return proto.entity.UpdateOrganizationAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateOrganizationAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateOrganizationAction}
 */
proto.entity.UpdateOrganizationAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.UpdateOrganizationAction.SetNameAction;
      reader.readMessage(value,proto.entity.UpdateOrganizationAction.SetNameAction.deserializeBinaryFromReader);
      msg.setSetName(value);
      break;
    case 2:
      var value = new proto.entity.UpdateOrganizationAction.SetDetailsAction;
      reader.readMessage(value,proto.entity.UpdateOrganizationAction.SetDetailsAction.deserializeBinaryFromReader);
      msg.setSetDetails(value);
      break;
    case 3:
      var value = new proto.entity.UpdateOrganizationAction.SetInternalDetailsAction;
      reader.readMessage(value,proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.deserializeBinaryFromReader);
      msg.setSetInternalDetails(value);
      break;
    case 4:
      var value = new proto.entity.UpdateOrganizationAction.SetDeletedAction;
      reader.readMessage(value,proto.entity.UpdateOrganizationAction.SetDeletedAction.deserializeBinaryFromReader);
      msg.setSetDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateOrganizationAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateOrganizationAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateOrganizationAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOrganizationAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetName();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.UpdateOrganizationAction.SetNameAction.serializeBinaryToWriter
    );
  }
  f = message.getSetDetails();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.entity.UpdateOrganizationAction.SetDetailsAction.serializeBinaryToWriter
    );
  }
  f = message.getSetInternalDetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.serializeBinaryToWriter
    );
  }
  f = message.getSetDeleted();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.entity.UpdateOrganizationAction.SetDeletedAction.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateOrganizationAction.SetNameAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateOrganizationAction.SetNameAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateOrganizationAction.SetNameAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOrganizationAction.SetNameAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    newName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateOrganizationAction.SetNameAction}
 */
proto.entity.UpdateOrganizationAction.SetNameAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateOrganizationAction.SetNameAction;
  return proto.entity.UpdateOrganizationAction.SetNameAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateOrganizationAction.SetNameAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateOrganizationAction.SetNameAction}
 */
proto.entity.UpdateOrganizationAction.SetNameAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateOrganizationAction.SetNameAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateOrganizationAction.SetNameAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateOrganizationAction.SetNameAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOrganizationAction.SetNameAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string new_name = 1;
 * @return {string}
 */
proto.entity.UpdateOrganizationAction.SetNameAction.prototype.getNewName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UpdateOrganizationAction.SetNameAction} returns this
 */
proto.entity.UpdateOrganizationAction.SetNameAction.prototype.setNewName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateOrganizationAction.SetDetailsAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateOrganizationAction.SetDetailsAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateOrganizationAction.SetDetailsAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOrganizationAction.SetDetailsAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    newDetails: (f = msg.getNewDetails()) && proto.entity.OrganizationDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateOrganizationAction.SetDetailsAction}
 */
proto.entity.UpdateOrganizationAction.SetDetailsAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateOrganizationAction.SetDetailsAction;
  return proto.entity.UpdateOrganizationAction.SetDetailsAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateOrganizationAction.SetDetailsAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateOrganizationAction.SetDetailsAction}
 */
proto.entity.UpdateOrganizationAction.SetDetailsAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.OrganizationDetails;
      reader.readMessage(value,proto.entity.OrganizationDetails.deserializeBinaryFromReader);
      msg.setNewDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateOrganizationAction.SetDetailsAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateOrganizationAction.SetDetailsAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateOrganizationAction.SetDetailsAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOrganizationAction.SetDetailsAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewDetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.OrganizationDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional OrganizationDetails new_details = 1;
 * @return {?proto.entity.OrganizationDetails}
 */
proto.entity.UpdateOrganizationAction.SetDetailsAction.prototype.getNewDetails = function() {
  return /** @type{?proto.entity.OrganizationDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.OrganizationDetails, 1));
};


/**
 * @param {?proto.entity.OrganizationDetails|undefined} value
 * @return {!proto.entity.UpdateOrganizationAction.SetDetailsAction} returns this
*/
proto.entity.UpdateOrganizationAction.SetDetailsAction.prototype.setNewDetails = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateOrganizationAction.SetDetailsAction} returns this
 */
proto.entity.UpdateOrganizationAction.SetDetailsAction.prototype.clearNewDetails = function() {
  return this.setNewDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateOrganizationAction.SetDetailsAction.prototype.hasNewDetails = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateOrganizationAction.SetInternalDetailsAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    newInternalDetails: (f = msg.getNewInternalDetails()) && proto.entity.InternalOrganizationDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateOrganizationAction.SetInternalDetailsAction}
 */
proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateOrganizationAction.SetInternalDetailsAction;
  return proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateOrganizationAction.SetInternalDetailsAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateOrganizationAction.SetInternalDetailsAction}
 */
proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.InternalOrganizationDetails;
      reader.readMessage(value,proto.entity.InternalOrganizationDetails.deserializeBinaryFromReader);
      msg.setNewInternalDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateOrganizationAction.SetInternalDetailsAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewInternalDetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.InternalOrganizationDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional InternalOrganizationDetails new_internal_details = 1;
 * @return {?proto.entity.InternalOrganizationDetails}
 */
proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.prototype.getNewInternalDetails = function() {
  return /** @type{?proto.entity.InternalOrganizationDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.InternalOrganizationDetails, 1));
};


/**
 * @param {?proto.entity.InternalOrganizationDetails|undefined} value
 * @return {!proto.entity.UpdateOrganizationAction.SetInternalDetailsAction} returns this
*/
proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.prototype.setNewInternalDetails = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateOrganizationAction.SetInternalDetailsAction} returns this
 */
proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.prototype.clearNewInternalDetails = function() {
  return this.setNewInternalDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateOrganizationAction.SetInternalDetailsAction.prototype.hasNewInternalDetails = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateOrganizationAction.SetDeletedAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateOrganizationAction.SetDeletedAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateOrganizationAction.SetDeletedAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOrganizationAction.SetDeletedAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    newDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateOrganizationAction.SetDeletedAction}
 */
proto.entity.UpdateOrganizationAction.SetDeletedAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateOrganizationAction.SetDeletedAction;
  return proto.entity.UpdateOrganizationAction.SetDeletedAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateOrganizationAction.SetDeletedAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateOrganizationAction.SetDeletedAction}
 */
proto.entity.UpdateOrganizationAction.SetDeletedAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNewDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateOrganizationAction.SetDeletedAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateOrganizationAction.SetDeletedAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateOrganizationAction.SetDeletedAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOrganizationAction.SetDeletedAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewDeleted();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool new_deleted = 1;
 * @return {boolean}
 */
proto.entity.UpdateOrganizationAction.SetDeletedAction.prototype.getNewDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.UpdateOrganizationAction.SetDeletedAction} returns this
 */
proto.entity.UpdateOrganizationAction.SetDeletedAction.prototype.setNewDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional SetNameAction set_name = 1;
 * @return {?proto.entity.UpdateOrganizationAction.SetNameAction}
 */
proto.entity.UpdateOrganizationAction.prototype.getSetName = function() {
  return /** @type{?proto.entity.UpdateOrganizationAction.SetNameAction} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateOrganizationAction.SetNameAction, 1));
};


/**
 * @param {?proto.entity.UpdateOrganizationAction.SetNameAction|undefined} value
 * @return {!proto.entity.UpdateOrganizationAction} returns this
*/
proto.entity.UpdateOrganizationAction.prototype.setSetName = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.entity.UpdateOrganizationAction.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateOrganizationAction} returns this
 */
proto.entity.UpdateOrganizationAction.prototype.clearSetName = function() {
  return this.setSetName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateOrganizationAction.prototype.hasSetName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SetDetailsAction set_details = 2;
 * @return {?proto.entity.UpdateOrganizationAction.SetDetailsAction}
 */
proto.entity.UpdateOrganizationAction.prototype.getSetDetails = function() {
  return /** @type{?proto.entity.UpdateOrganizationAction.SetDetailsAction} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateOrganizationAction.SetDetailsAction, 2));
};


/**
 * @param {?proto.entity.UpdateOrganizationAction.SetDetailsAction|undefined} value
 * @return {!proto.entity.UpdateOrganizationAction} returns this
*/
proto.entity.UpdateOrganizationAction.prototype.setSetDetails = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.entity.UpdateOrganizationAction.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateOrganizationAction} returns this
 */
proto.entity.UpdateOrganizationAction.prototype.clearSetDetails = function() {
  return this.setSetDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateOrganizationAction.prototype.hasSetDetails = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SetInternalDetailsAction set_internal_details = 3;
 * @return {?proto.entity.UpdateOrganizationAction.SetInternalDetailsAction}
 */
proto.entity.UpdateOrganizationAction.prototype.getSetInternalDetails = function() {
  return /** @type{?proto.entity.UpdateOrganizationAction.SetInternalDetailsAction} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateOrganizationAction.SetInternalDetailsAction, 3));
};


/**
 * @param {?proto.entity.UpdateOrganizationAction.SetInternalDetailsAction|undefined} value
 * @return {!proto.entity.UpdateOrganizationAction} returns this
*/
proto.entity.UpdateOrganizationAction.prototype.setSetInternalDetails = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.entity.UpdateOrganizationAction.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateOrganizationAction} returns this
 */
proto.entity.UpdateOrganizationAction.prototype.clearSetInternalDetails = function() {
  return this.setSetInternalDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateOrganizationAction.prototype.hasSetInternalDetails = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SetDeletedAction set_deleted = 4;
 * @return {?proto.entity.UpdateOrganizationAction.SetDeletedAction}
 */
proto.entity.UpdateOrganizationAction.prototype.getSetDeleted = function() {
  return /** @type{?proto.entity.UpdateOrganizationAction.SetDeletedAction} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateOrganizationAction.SetDeletedAction, 4));
};


/**
 * @param {?proto.entity.UpdateOrganizationAction.SetDeletedAction|undefined} value
 * @return {!proto.entity.UpdateOrganizationAction} returns this
*/
proto.entity.UpdateOrganizationAction.prototype.setSetDeleted = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.entity.UpdateOrganizationAction.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateOrganizationAction} returns this
 */
proto.entity.UpdateOrganizationAction.prototype.clearSetDeleted = function() {
  return this.setSetDeleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateOrganizationAction.prototype.hasSetDeleted = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.entity);
